import { useState } from 'react'
import cx from 'classnames'
import Styles from './useAutopilotUpgradeBanner.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { Close, Lightning } from 'blaze-ui/icons'
import { useModals } from 'almanac-ui/Modal'
import { AutopilotUpgradeModal } from 'components/AutopilotUpgradeModal/AutopilotUpgradeModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useOpenSettings } from 'hooks/useOpenSettings'
import { SettingScreen } from 'components/Settings/types'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

const DISMISSAL_KEY = 'autopilot-upgrade-banner-dismissed'

export const useAutopilotUpgradeBanner = () => {
  const { openModal } = useModals()
  const { isMobile, isIOSNative } = useResponsiveDesign()
  const isAPMobileWeb = useAPMobileWeb()
  const workspace = useCurrentWorkspace()
  const [localDismissed, setLocalDismissed] = useState(false)

  const dismissed = localDismissed || !!localStorage.getItem(DISMISSAL_KEY)
  const showBanner = workspace && !workspace?.is_virtual_marketer && !isIOSNative && !isAPMobileWeb && !dismissed
  const blackFridayCtaEnabled = useFlipperFlag('black_friday_cta')
  const { openSettings } = useOpenSettings()

  const openAutopilotUpgradeModal = () => {
    openModal(
      AutopilotUpgradeModal,
      {},
      {
        underlayVariant: isMobile ? 'mobileAutopilotUpgrade' : 'autopilotUpgrade',
      },
    )
  }

  const handlePress = () => {
    if (blackFridayCtaEnabled) {
      openSettings(SettingScreen.Billing)
      return
    }

    openAutopilotUpgradeModal()
  }

  let message = isMobile
    ? 'Introducing Blaze Autopilot. Try free for 7 days.'
    : 'Introducing Blaze Autopilot. Try free in a new workspace for 7 days.'

  message = blackFridayCtaEnabled ? 'Black Friday Starts Now — Save 60% on Annual CoPilot Subscriptions' : message

  const autopilotUpgradeBanner = (
    <div className={cx(Styles.container, { [Styles.blackFridayCta]: blackFridayCtaEnabled })}>
      {!blackFridayCtaEnabled && <Lightning color="var(--light-100)" />}
      <div className={Styles.message}>
        <Text variant="secondary" color="var(--light-100)">
          {message}
        </Text>
      </div>
      <div className={Styles.buttonContainer}>
        <Button size={isMobile ? 'sm' : 'xs'} onPress={handlePress} variant="secondary">
          {blackFridayCtaEnabled ? 'Upgrade and Save' : 'Try Autopilot'}
        </Button>
      </div>
      <div className={Styles.close}>
        <Button
          aria-label="Dismiss Banner"
          onPress={() => {
            localStorage.setItem(DISMISSAL_KEY, 'true')
            setLocalDismissed(true)
          }}
          variant="tertiary"
          size="xs"
        >
          <Close size={16} color="var(--light-100)" />
        </Button>
      </div>
    </div>
  )

  return {
    showBanner,
    autopilotUpgradeBanner,
  }
}
